<template>
    <div>
        <HelloWorld :loginFlag="loginFlag" :userName="userName"></HelloWorld>
        <div class="bg-image" style="height: 400px;">
            <div style="background: rgba(0, 0, 0, 0.7); z-index: 1; height: 100%;">
                <div style="margin: 0px auto; width: 85%; height: 200px; padding-top: 200px;">
                    <div style="color: #ffffff;">
                        <div style="width: 100%; height: 25px;">
                            <h2>
                                <el-image :src="require('@/assets/images/logo.jpg')" style="float: left; width: 35px; border-radius: 10px;"></el-image>
                                <div style="margin-left: 10px; float: left;">XUS商城系统</div>
                            </h2>
                        </div>
                        <div style="font-size: 18px; color: #ffffff; margin-top: 10px; margin-top: 30px;">
                            关于我们
                        </div>
                        <div style="margin-top: 20px; height: 2px; background-color: #ffffff; width: 20%;"></div>
                        <div style="font-size: 13px; color: #ffffff; margin-top: 20px;">
                            旭杉（沈阳市）网络科技有限公司
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="width: 100%; color: #000000; background-color: #ffffff; width: 75%; margin: 0px auto; margin-top: 30px; padding: 45px; border-radius: 20px; border: 1px  solid #999999;">
            <h4>
                XUS数字商城，专注于中国虚拟数字权益解决方案，以创新为引擎，以技术为支撑，致力于为企业提供全面、高效的数字产品销售及解决方案。我们供应权益卡券、虚拟充值、游戏点卡、影音会员等多元化产品，以满足不同企业的需求。
            </h4>
            <div style="margin-top: 20px;">
                XUS数字商城凭借专业的技术实力和丰富的行业经验，已成功为众多企业提供了可靠的数字产品销售和电商私域流量变现服务。我们理解每个企业都有其独特的需求和挑战，因此我们量身定制解决方案，帮助企业在竞争激烈的市场中脱颖而出。
            </div>
            <div style="margin-top: 20px;">
                <span style="font-weight: bold;">XUS数字商城的特色：DeepSeek智能AI客服，让创业者彻底解放双手</span><br/>
                √ 24/7全天候响应：告别人工客服的等待与延迟，AI客服秒级回复买家咨询。<br/>
                √ 智能学习与进化：AI深度理解客户需求，越用越懂您的业务，回复精准度高达95%。<br/>
                √ 多场景无缝切换：支持售前咨询、售后跟进、订单查询等全流程服务，真正实现脱手管理。<br/>
                √ 成本直降70%：无需雇佣客服团队，AI客服一次性投入，长期高效运转。
            </div>
            <div style="margin-top: 20px;">
                XUS数字商城致力于为企业提供全方位的数字权益解决方案，助力企业增长开拓。我们相信，通过我们的专业服务和技术支持，企业能够实现数字化转型，提高运营效率，实现持续增长。
            </div>

            <div style="margin-top: 20px; font-weight: bold;">
                选择XUS数字商城，让AI为您打工，创业从此轻松无忧！
            </div>
        </div>

        <!-- 底部 -->
        <div style="background-color: #000000; margin-top: 20px; color: #ffffff;">
            <div style="padding-top: 20px; margin-left: 20px; width: 80%; margin: 0px auto;">
                <h3>联系我们</h3>
                <div style="margin-top: 10px;">
                    官方微信：l13514269986、qwdjpk
                </div>
                <div style="margin-top: 10px;">
                    官方qq：2950164010
                </div>
                <div style="margin-top: 10px;">
                    官方电话：13514269986
                </div>
            </div>
            <div style="border: 1px solid #5d5d5d; width: 80%; margin: 0px auto; margin-top: 10px; margin-bottom: 10px;"></div>
            <div style="text-align: center; padding-bottom: 10px;">
                旭杉（沈阳市）网络科技有限公司<br />
                <a href="https://beian.miit.gov.cn" style="color: #ffffff">辽ICP备2023013240号</a><br />
                <a href="https://beian.miit.gov.cn" style="color: #ffffff"> 增值电信业务经营许可证: 辽B2-20240456号 </a>
            </div>
        </div>
    </div>
</template>

<script>
    import HelloWorld from '@/components/top-bar.vue'
    export default {
        components: {
            HelloWorld
        },
        data() {
            return {
                loginFlag: '',
                userName: ''
            }
        },
        mounted() {
            this.loginFlag = !localStorage.getItem('userTK') == ''
            this.userName = localStorage.getItem('userName')
        },
    }
</script>

<style scoped>

    .bg-image {
        background-image: url('/src/assets/images/xus4.png');
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>